function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { LayerGroup } from '../../../../model/LayerGroup';
var _sortGroupsAlphabetically = function sortGroupsAlphabetically() {
  var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!Array.isArray(groups)) {
    return null;
  }
  var sorted = _toConsumableArray(groups).sort(function (a, b) {
    // ensure that empty groups are at the top
    // not sure if this is requested functionality or not
    var layerCountA = a.getLayerCount();
    var layerCountB = b.getLayerCount();
    if (layerCountA === 0 && layerCountB !== 0) {
      return -1;
    }
    if (layerCountA !== 0 && layerCountB === 0) {
      return 1;
    }
    // sort by name (for most cases use this)
    return Oskari.util.naturalSort(a.getTitle(), b.getTitle());
  });
  sorted.forEach(function (group) {
    group.setGroups(_sortGroupsAlphabetically(group.getGroups()));
  });
  return sorted;
};
var layerSortFn = function layerSortFn(a, b) {
  var delta = Oskari.util.naturalSort(a.getName(), b.getName());
  if (delta !== 0) {
    return delta;
  }
  return a.getLayerType().localeCompare(b.getLayerType());
};

/*
const group = {
    id: -1,
    name: '',
    layers: [{id}],
    groups: []
};
createGroupModel(group, ...)
*/
var _createGroupModel = function createGroupModel(group, method, allLayers, tools) {
  var newGroup = new LayerGroup(group.id, method, group.name, group.description);
  newGroup.setTools(tools);
  // attach layers to group
  var groupLayers = group.layers || [];
  var groupLayerIds = groupLayers.map(function (l) {
    return l.id;
  });
  if (groupLayerIds.length) {
    // since allLayers can be long we don't need to filter it if there
    // isn't any layers to be added
    var layerModels = allLayers.filter(function (layer) {
      if (typeof layer.getId !== 'function') {
        return false;
      }
      return groupLayerIds.includes(layer.getId());
    });
    layerModels.sort(layerSortFn);
    newGroup.setLayers(layerModels);
  }

  // group has subgroups
  if (!group.groups.length) {
    // has layers but no subgroups
    return newGroup;
  }
  var mappedSubgroups = group.groups
  // recursion for subgroups
  .map(function (subgroup) {
    return _createGroupModel(subgroup, method, allLayers, tools);
  })
  // remove any subgroups that mapped to null:
  //  (groups without layers for non-admins etc)
  .filter(function (g) {
    return typeof g !== 'undefined';
  });
  newGroup.setGroups(mappedSubgroups);
  return newGroup;
};

// If a group has no layers and no subgroups with layers -> group needs to gets filtered out
// This is required since previous processing only filters out groups that don't have
//  neither layers or subgroups. Without this we might still end up with groups without
//  layers that have with subgroups without layers
var _filterOutEmptyGroups = function filterOutEmptyGroups() {
  var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return groups.map(function (group) {
    group.groups = _filterOutEmptyGroups(group.groups);
    if (!group.layers.length && !group.groups.length) {
      // no layers and no subgroups with layers
      return null;
    }
    return group;
  }).filter(function (group) {
    return !!group;
  });
};
/**
 * Function to construct layer groups based on information included in layers and given grouping method.
 * Possible empty groups are included if allGroups and / or allDataProviders parameters are provided.
 *
 * @param {Oskari.mapframework.domain.AbstractLayer[]} layers layers to group
 * @param {String} method layer method name to sort by like "getInspireTheme"
 * @param {Oskari.mapframework.domain.Tool[]} tools tools to group
 * @param {Object[]} allGroups all layer groups or all dataproviders available in Oskari
 * @param {String} noGroupTitle title on UI for group that has layers without a group
 * @param {Boolean} isPresetFiltered if filtered -> remove empty groups even for admin
 */
export var groupLayers = function groupLayers(layers, method, tools) {
  var allGroups = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var noGroupTitle = arguments.length > 4 ? arguments[4] : undefined;
  var isPresetFiltered = arguments.length > 5 ? arguments[5] : undefined;
  var groupForOrphans = null;
  var isUserAdmin = tools.length > 0;
  // generate a group for layers without "natural" grouping if needed
  layers.filter(function (layer) {
    return !layer.getMetaType || layer.getMetaType() !== 'published';
  })
  // if method call returns a value we can map it to a group, filter ones we can't
  .filter(function (layer) {
    return !layer[method]();
  }).forEach(function (layer) {
    if (groupForOrphans) {
      // add layer to runtime generated orphan group
      groupForOrphans.addLayer(layer);
      return;
    }
    // Create group for orphan layers if not already created
    var newGroup = {
      // My map layers, my places, own analysis and 'orphan' groups don't have id so use negated random number
      // as unique Id (with positive id group is interpret as editable and group tools are shown in layer list).
      id: -Math.random(),
      name: '(' + noGroupTitle + ')',
      layers: [{
        id: layer.getId()
      }],
      groups: []
    };
    groupForOrphans = _createGroupModel(newGroup, method, layers, tools);
  });
  // recursively map groups and layers together
  var groupList = allGroups.map(function (rootGroup) {
    return _createGroupModel(rootGroup, method, layers, tools);
  }).filter(function (group) {
    return typeof group !== 'undefined';
  });
  var emptyGroupsShouldBeListed = isUserAdmin && !isPresetFiltered;
  var sortedGroups = _sortGroupsAlphabetically(emptyGroupsShouldBeListed ? groupList : _filterOutEmptyGroups(groupList));
  var result = _toConsumableArray(sortedGroups);
  if (groupForOrphans) {
    // if there's an orphan group, make it the first one
    result.unshift(groupForOrphans);
  }
  return result;
};